export const getters = {
  getFuncionario: (state) => state.funcionario,
  getFuncionarios: (state) => state.funcionarios,
  getModalCadastroFuncionario: (state) => state.modalCadastrarFuncionario,
  getModalExcluirFuncionario: (state) => state.modalExcluirFuncionario,
  getModalPesquisarFuncionario: (state) => state.modalPesquisarFuncionario,
  getModalPermissaoFuncionario: (state) => state.modalPermissaoFuncionario,
  getPermissaoFuncionario: (state) => state.permissaoFuncionario,
  getSalario: state => state.salario,
  getDependente: state => state.dependente,
  getSalarios: state => state.salarios,
  getDependentes: state => state.dependentes
};

export default {};
